export const async_google_maps_search = {
  asyncType: 'google-maps-search',
  hostedScraperType:  'async_google_maps_search',
  publicHostedScraperAPIType:  'google_maps_search',
  inputKey: 'query',
  inputsKey: 'queries',
  inputJsonSchema: { type: 'string' },
  asyncEndpoint: '/structured/google/mapssearch',
  apiEndpoint: '/structured/google/mapssearch',
  apiCostEndpoint: '/account/googlemapssearchcost',
  propertiesJsonSchemaPart: {
    output_format: { type: 'string', enum: [ 'csv', 'json' ] },
    tld: { type: 'string' },
    country_code: { type: 'string' },
    latitude: { type: 'number' },
    longitude: { type: 'number' },
    zoom: { type: 'number' },
    include_html: { type: 'boolean' },
  }
};
